var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 2",
    width: 600,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 0.6666667,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.6666667,
    width: 3,
    height: 0.6666667,
    fill: "#0039A6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1.3333333,
    width: 3,
    height: 0.6666667,
    fill: "#D52B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuflag);
export default __webpack_public_path__ + "static/media/ruflag.3cbe895e1612e0e9486d4d00a819bd09.svg";
export { ForwardRef as ReactComponent };